<div id="content" class="disable-right-click">
  <!-- an hidden div is created to set the position of appearance of the menu-->
  <div
    style="visibility: hidden; position: fixed"
    [style.left]="menuTopLeftPosition.x"
    [style.top]="menuTopLeftPosition.y"
    matMenuTrigger
    [matMenuTriggerFor]="rightMenu"
  ></div>
  <!-- standard material menu -->
  <mat-menu #rightMenu="matMenu">
    <ng-template matMenuContent let-item="item">
      @if (this.isUserAdmin()) {
        @if (item.type === 'WikiNode') {
          <button mat-menu-item (click)="deleteNode()">Borrar carpeta</button>
        }
        @if (item.type === 'WikiNode') {
          <button mat-menu-item (click)="editWikiNode()">Editar carpeta</button>
        }
        @if (item.type === 'WikiArticle') {
          <button mat-menu-item (click)="deleteArticle()">Borrar documento</button>
          <button mat-menu-item (click)="editArticle()">Editar permisos</button>
        }
      }
      <button mat-menu-item (click)="showMoveWikiItemDialog()">Mover</button>
    </ng-template>
  </mat-menu>
  <div class="page-title">
    <h1>{{ page_title }}</h1>
  </div>

  <div class="row g-2">
    @for (element of wikiTree; track element) {
      <div class="col col-sm-4 col-md-6" (contextmenu)="onRightClick($event, element, 'WikiNode')">
        <div class="card folder" [routerLink]="['/employees', 'wiki', element.id]">
          <mat-icon>{{ element.icon != null ? element.icon : 'folder' }}</mat-icon>
          <mat-icon class="icon-background">{{ element.icon != null ? element.icon : 'folder' }}</mat-icon>
          <div class="title">{{ element.name }}</div>
        </div>
      </div>
    }
  </div>
</div>
